import React from "react";
import { Bar } from "react-chartjs-2";
import { defaults } from "chart.js/auto";
import { useSelector } from "react-redux";
import { RootState } from "src/redux/store";
import { CircularProgress } from "@mui/material";
import FollowupsListingWrapper from "../Dashboard2/Followups/List/FollowupsListingWrapper";
import DueAmountListingWrapper from "../Dashboard2/List/DashboardListingWrapper";

defaults.maintainAspectRatio = false;
defaults.responsive = true;
defaults.plugins.title.display = true;
defaults.plugins.title.align = "center";
defaults.plugins.title.color = "black";

const Dashboard = () => {
  const {
    weeklySales,
    todaySales,
    monthlySales,
    todayIsloading,
    monthlyIsloading,
    weeklyIsloading,
  } = useSelector((state: RootState) => state.dashboard);

 const renderChart = (label: string, salesData: any, isLoading: boolean) => (
  <div className="dataCard subjectCard relative w-full min-w-[300px]">
    {isLoading && (
      <div className="absolute flex justify-center items-center w-full h-full z-10 text-black" style={{ backgroundColor: "rgba(255, 255, 255, 0.4)" }}>
        <CircularProgress />
      </div>
    )}
    <Bar
      data={{
        labels: [label],
        datasets: [
          {
            label: "Total Fees",
            data: [salesData?.totalAmount || 0],
            backgroundColor: "rgba(43, 63, 229, 0.8)",
            borderRadius: 5,
          },
          {
            label: "Order Count",
            data: [salesData?.totalOrderCount || 0],
            backgroundColor: "rgba(255, 99, 132, 0.8)",
            borderRadius: 5,
          },
        ],
      }}
      options={{
        plugins: {
          title: {
            text: label,
          },
        },
        responsive: true,
        maintainAspectRatio: false,
      }}
    />
  </div>
);


  return (
    <div className="bg-white overflow-hidden">
      <div className="flex gap-2 m-2 p-2 overflow-x-auto">
        {renderChart("Sales Daily Data", todaySales, todayIsloading)}
        {renderChart("Sales Weekly Data", weeklySales, weeklyIsloading)}
        {renderChart("Sales Monthly Data", monthlySales, monthlyIsloading)}
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-1">
        <div className="shadow-xxl rounded-lg border m-2">
          <DueAmountListingWrapper />
        </div>
        <div className="m-2 shadow-xxl rounded-lg border p-1">
          <FollowupsListingWrapper />
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
